import { motion } from "framer-motion";
import { Zap, Infinity as InfinityIcon, ShieldCheck, Smartphone } from "lucide-react";
import BuyButton from "./CtaButton";
import { PRICE } from "../config";

const BADGES = [
    [Zap, "Instant Delivery"],
    [InfinityIcon, "Lifetime Access"],
    [ShieldCheck, "100% Secure Checkout"],
    [Smartphone, "Works on All Devices"],
];

export default function FinalCta() {
    return (
        <section
            data-testid="final-cta-banner"
            className="bg-white px-4 pb-16 pt-4 sm:px-6 sm:pb-24"
        >
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7 }}
                className="mx-auto max-w-4xl text-center"
            >
                <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-4xl lg:text-[2.9rem]">
                    Don't Buy Books One-by-One —{" "}
                    <span className="text-emerald-600">
                        Own the Entire Library Forever
                    </span>
                </h2>
                <p className="mt-5 text-sm font-medium text-slate-600 sm:text-base">
                    12,000+ eBooks · 16+ categories · 500GB audiobooks bonus ·
                    Lifetime access.
                </p>
                <p className="mt-1 text-sm font-medium text-slate-600 sm:text-base">
                    One tiny payment today. No subscriptions. No renewals. Ever.
                </p>
                <div className="mt-8 flex justify-center">
                    <BuyButton
                        testId="final-cta-btn"
                        className="cta-pulse w-full sm:w-auto"
                    >
                        Get Instant Access — ₹{PRICE.current}
                    </BuyButton>
                </div>
                <p className="mt-4 flex items-center justify-center gap-2 text-xs font-semibold text-slate-600 sm:text-sm">
                    <ShieldCheck size={15} className="text-emerald-600" />
                    Money-Back Guarantee — full refund within 24 hours of
                    purchase
                </p>
                <div className="mt-9 flex flex-wrap items-center justify-center gap-x-7 gap-y-3">
                    {BADGES.map(([Icon, label]) => (
                        <span
                            key={label}
                            className="flex items-center gap-2 text-xs font-medium text-slate-500 sm:text-sm"
                        >
                            <Icon size={15} className="text-emerald-600" />
                            {label}
                        </span>
                    ))}
                </div>
            </motion.div>
        </section>
    );
}
